import React, { useEffect } from "react";
import Forms from "../../../components/common/Form";
import formConfig from "../../../formJsonData/Operations/Invoice/ClientWiseInvoice.json";
import searchConfigJson from "../../../formJsonData/LMS/searchFilterFields.json";
import { decryptDataForURL } from "../../../utills/useCryptoUtils";
import { formatIndianNumber } from "../../../services/commonFunction";
import { useSelector } from "react-redux";

const ClientWiseInvoices = ({ useFor }) => {
  const session = useSelector((state) => state.session);
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const client_id = decryptDataForURL(params.get("client_id"));
  const company_id = decryptDataForURL(params.get("company_id"));
  const outstandingData = session.outstandingViewData?.data;
  const onaccount = outstandingData?.onaccount;
  const current_outstanding = outstandingData?.current_outstanding;
  const old_outstanding = outstandingData?.old_outstanding;
  const old_fin_year_outstanding = outstandingData?.old_fin_year_outstanding;
  // const fin_yr = decryptDataForURL(params.get("fin_yr"));
  let searchOPT = searchConfigJson.invoiceList;
  const newConfig = {
    ...formConfig,
    apiEndpoints: {
      ...formConfig.apiEndpoints,
      read: `/client-outstanding/invoices/?client_id=${client_id}&company_id=${company_id}`,
      exportExcel: `/client-outstanding/invoices/excel/?client_id=${client_id}&company_id=${company_id}`,
    },
    listView: {
      ...formConfig.listView,
      title: `Invoice Details (Curr. Outst. = ${formatIndianNumber(current_outstanding || 0)}, Non-Sys Outst. = ${formatIndianNumber(old_outstanding || 0)}, Old Outst.=${formatIndianNumber(old_fin_year_outstanding || 0)}, On A/C = ${formatIndianNumber(onaccount || 0)})`,
    },
  };
  return (
    <div>
      <Forms formConfig={newConfig} searchConfigJson={[...searchOPT]} />
    </div>
  );
};

export default ClientWiseInvoices;
